"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var MuiThemeProvider_1 = __importDefault(require("material-ui/styles/MuiThemeProvider"));
var getMuiTheme_1 = __importDefault(require("material-ui/styles/getMuiTheme"));
var ThemeContainer = /** @class */ (function (_super) {
    __extends(ThemeContainer, _super);
    function ThemeContainer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.getTheme = function () { return getMuiTheme_1.default(_this.props.theme); };
        _this.render = function () {
            var _a = _this.props, theme = _a.theme, rest = __rest(_a, ["theme"]);
            return react_1.default.createElement(MuiThemeProvider_1.default, __assign({}, rest, { muiTheme: _this.getTheme() }));
        };
        return _this;
    }
    return ThemeContainer;
}(react_1.default.Component));
exports.default = ThemeContainer;
//# sourceMappingURL=ThemeContainer.js.map


//////////////////
// WEBPACK FOOTER
// .-core/es/components/app/ThemeContainer.js
// module id = 1626
// module chunks = 0